import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'login-layout',
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginLayoutComponent {}
